import React from 'react';
import { PageHeader } from '../components/layout/PageHeader';
import { CtaBand } from '../components/ui/CtaBand';
import { FaqList } from '../components/ui/FaqList';
import { SectionHeading } from '../components/ui/SectionHeading';
import { faqs, steps } from '../data/site';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { useBrand } from '../contexts/BrandContext';
export function HowItWorks() {
  const {
    brand,
    text
  } = useBrand();
  useDocumentMeta({
    title: `How care works — ${brand.name}`,
    description: 'Tell us what is going on, get tested, read the plan, adjust as the numbers move. A clinic that shows its work.'
  });
  return <main data-id="element-405" data-mp="1taosgq88tu3a">
      <PageHeader eyebrow="How it works" title="A clinic that shows its work." intro="Same four steps for everyone: tell us what is going on, get your blood tested, read the plan, then adjust it as the numbers move. No mystery, no runaround." data-id="element-406" data-mp="1taf2v3r41oy4" />

      <section className="bg-cream" data-id="element-407" data-mp="10s1ctqc0n79l">
        <div className="mx-auto max-w-shell px-6 pb-16 md:px-8 md:pb-24" data-id="element-408" data-mp="1rrwp8nqodco6">
          <ol className="grid gap-6 lg:grid-cols-2" data-id="element-409" data-mp="1nq1n5h0x6v9c">
            {steps.map((step, index) => <li key={step.label} className="rounded-brand border border-ink/10 bg-cream-light p-8" data-id="element-410" data-mp="1izcwu50z84bs" data-mpi={index}>
                <div className="flex items-baseline justify-between" data-id="element-411" data-mp="1dzgusbbuamyv">
                  <span className="font-serif text-3xl font-bold text-brick" data-id="element-412" data-mp="191otwrt7vqij">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <span className="text-[0.625rem] uppercase tracking-label text-ink-muted" data-id="element-413" data-mp="1446ovciblvft">
                    {step.duration}
                  </span>
                </div>
                <h2 className="mt-5 font-serif text-2xl font-semibold leading-snug text-ink" data-id="element-414" data-mp="v2yvn8unvksl">
                  {step.title}
                </h2>
                <p className="mt-3 max-w-xl text-base leading-relaxed text-ink-soft" data-id="element-415" data-mp="2pfoorod7gpyx">
                  {text(step.detail)}
                </p>
              </li>)}
          </ol>
        </div>
      </section>

      <section className="bg-ink text-cream" data-id="element-416" data-mp="3db0enxcx6u7w">
        <div className="mx-auto max-w-shell px-6 py-16 md:px-8 md:py-24" data-id="element-417" data-mp="3dcv1xibnyyf5">
          <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20" data-id="element-418" data-mp="2zkn5jroal9gz">
            <img src={brand.images.clinician} alt={`A ${brand.name} doctor going through a member's results`} className="aspect-[3/2] w-full rounded-brand object-cover" data-id="element-419" data-mp="34hngoh0012ey" />
            <div data-id="element-420" data-mp="3oxywoe3m6x">
              <SectionHeading eyebrow="Your care team" tone="cream" title="One doctor. Not a queue." intro="You get a doctor licensed in your state who stays with you through every renewal, so you are not re-explaining your history to a stranger. Messages come back within a day, and changing your dose never costs extra." data-id="element-421" data-mp="24dy0zpblnb" />
              <dl className="rule-light mt-10 grid gap-8 pt-8 sm:grid-cols-3" data-id="element-422" data-mp="2brol02rau71b">
                {[{
                value: '< 24 hrs',
                label: 'Typical wait for your plan'
              }, {
                value: '2,100',
                label: 'Places to get blood drawn'
              }, {
                value: '50',
                label: 'States we are licensed in'
              }].map(stat => <div key={stat.label} data-id="element-423" data-mp="28cwve8p5kln1">
                    <dt className="font-serif text-3xl font-bold text-copper" data-id="element-424" data-mp="289r6oukfrlru">{stat.value}</dt>
                    <dd className="mt-2 text-sm leading-relaxed text-cream/70" data-id="element-425" data-mp="1kk6l03wweaev">{stat.label}</dd>
                  </div>)}
              </dl>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-cream-light" data-id="element-426" data-mp="1plce42ugzzox">
        <div className="mx-auto max-w-shell px-6 py-16 md:px-8 md:py-24" data-id="element-427" data-mp="1pkazjoe8wv2g">
          <div className="grid gap-8 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20" data-id="element-428" data-mp="11v9nlr67f1sf">
            <SectionHeading eyebrow="FAQ" title="The questions people actually ask." data-id="element-429" data-mp="wwomzqn1ig3g" />
            <FaqList items={faqs} data-id="element-430" data-mp="wulw74e2cixo" />
          </div>
        </div>
      </section>

      <CtaBand data-id="element-431" data-mp="1akyp8w4rtuop" />
    </main>;
}